var map = {
	"./VICTORY-FULL.mp3": 292,
	"./VICTORY1.mp3": 301,
	"./VICTORY2.mp3": 302,
	"./VICTORY3.mp3": 303,
	"./VICTORY4.mp3": 304,
	"./VICTORY5.mp3": 305,
	"./VICTORY6.mp3": 306,
	"./VICTORY7.mp3": 307,
	"./VICTORY8.mp3": 308
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/VICTORY.*\.mp3$
// module id = 293
// module chunks = 1 2 3